/**
 * Configuration de l'application
 */
export default {
  enableOffLineMode: true,
  prefixLocalStorage: 'blank',
  reconciliationKey: 'blankReconciliations',
  reconciliationExpiration: 60, //Durée exprimée en minutes
}
